import React, { useState, useEffect, useRef } from "react";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Legend } from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";

ChartJS.register(ArcElement, Legend);

const InvestmentDetails = () => {
  const [filter, setFilter] = useState("");
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();
  const cardData = [
    {
      label: "Cash Account",
      amount: "4,530.00",
      accounts: 2,
      color: "bg-[#5D88F8] bg-opacity-50",
    },
    {
      label: "Fund Management",
      amount: "750.00",
      accounts: 1,
      color: "bg-[#996EE7] bg-opacity-50",
    },
    {
      label: "Securities",
      amount: "3,910.00",
      accounts: 1,
      color: "bg-[#F18C29] bg-opacity-50",
    },
    {
      label: "Trading",
      amount: "13,157,750.00",
      accounts: 2,
      color: "bg-[#DC4646] bg-opacity-50",
    },
    {
      label: "Custodian",
      amount: "0.00",
      accounts: 0,
      color: "bg-[#2DB0EC] bg-opacity-50",
    },
    {
      label: "My Investments",
      amount: "0.00",
      accounts: 0,
      color: "bg-[#6B68F2] bg-opacity-50",
    },
    {
      label: "Digital Assets",
      amount: "0.00",
      accounts: 0,
      color: "bg-[#34C046] bg-opacity-50",
    },
  ];
  const handleAmountChange = (event) => {
    // Remove any non-numeric characters except the comma
    const value = event.target.value.replace(/[^\d]/g, "");

    // Format the value as currency
    const formattedValue = new Intl.NumberFormat().format(value);

    // Set the formatted value
    setAmount(formattedValue);
  };
  const dataset = {
    labels: [
      "Australian Equity",
      "Australian Fixed Interest",
      "Australian Cash",
    ],
    datasets: [
      {
        data: [68, 17, 15], // Percentages
        backgroundColor: ["#68D391", "#F56565", "#4299E1"], // Matching colors
        hoverBackgroundColor: ["#48BB78", "#E53E3E", "#3182CE"], // Hover colors
        borderWidth: 1,
      },
    ],
  };
  const plugin = {
    id: "customCanvasBackgroundImage",
    beforeDraw: (chart) => {
      const { ctx, chartArea, data } = chart;
      const { top, bottom, left, right, width, height } = chartArea;
      const centerX = left + width / 2;
      const centerY = top + height / 2;

      const radius = Math.min(width, height) / 2; // Radius of the donut
      const fontSize = 14;

      ctx.save();
      ctx.font = `${fontSize}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw percentages and lines for each section
      const meta = chart.getDatasetMeta(0); // First dataset
      meta.data.forEach((arc, index) => {
        const angle = (arc.startAngle + arc.endAngle) / 2; // Middle angle of the segment
        const x = centerX + Math.cos(angle) * (radius / 1.8); // Adjust for inner placement of text
        const y = centerY + Math.sin(angle) * (radius / 1.8);
        const percentage = `${data.datasets[0].data[index].toFixed(1)}%`;

        // Get the color for this section
        const sectionColor = data.datasets[0].backgroundColor[index];

        // Calculate the position of the text with space between the center and the donut
        const textX = centerX + Math.cos(angle) * (radius / 2.5); // Pushing text further out
        const textY = centerY + Math.sin(angle) * (radius / 2.5);

        // Draw line pointing from text to the donut center
        ctx.beginPath();
        ctx.moveTo(x, y); // Starting point is the position of the percentage text
        ctx.lineTo(
          centerX + Math.cos(angle) * (radius / 1),
          centerY + Math.sin(angle) * (radius / 1)
        ); // Ending at the center of the donut
        ctx.strokeStyle = sectionColor; // Set line color to section's color
        ctx.lineWidth = 1; // Line width
        ctx.stroke();

        // Draw percentage text
        ctx.fillStyle = sectionColor; // Set text color to section's color
        ctx.fillText(percentage, textX, textY);
      });

      ctx.restore();
    },
  };

  const options = {
    cutout: "70%", // Creates the donut hole
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
      },
    },
  };

  const data = {
    accountBalance: {
      title: "Account Balance",
      date: "Nov, 2023",
      activeAccounts: "8",
      activePercent: "80%",
      portfolio: "$827,234,289.60",
      graphData: [
        { month: "Jan", value: 20 },
        { month: "Feb", value: 80 },
        { month: "Mar", value: 60 },
        { month: "Apr", value: 90 },
        { month: "May", value: 90 },
        { month: "Jun", value: 90 },
        { month: "Jul", value: 20 },
        { month: "Aug", value: 30 },
        { month: "Sep", value: 50 },
        { month: "Oct", value: 30 },
        { month: "Nov", value: 20 },
        { month: "Dec", value: 50 },
      ],
    },
    totalDeposit: {
      title: "Total Deposit",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
    totalWithdrawal: {
      title: "Total Withdrawal",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
  };
  return (
    <div className="pt-4 p-2">
      {/* Summary Cards */}
      <CustomCardSlider componentName="dashboard" cardData={cardData} />

      <div className="pt-4  text-xs overflow-x-auto  flex-wrap items-center">
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter("")}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            Model Portfolio
          </button>
          <button
            onClick={() => setFilter("pending")}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === "pending"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Current Target Allocation
          </button>
          <button
            onClick={() => setFilter("archived")}
            className={`px-4 py-2  ${
              filter === "archived"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            B. Moses Asset Management Visualization
          </button>
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Historical Performance
          </button>{" "}
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Disclaimer
          </button>{" "}
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Documents
          </button>{" "}
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Terms & Conditions /Descriptions{" "}
          </button>{" "}
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Investment Application
          </button>{" "}
          <button
            onClick={() => setFilter("active")}
            className={`px-4 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Electronic Execution
          </button>{" "}
          <button
            onClick={() => setFilter("test")}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "test" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            Executed as an Agreement
          </button>
        </div>
      </div>
      <div className="p-4 bg-white rounded-lg shadow-lg">
        {/* Header Section */}
        <div className="flex justify-between items-start flex-wrap">
          {/* Title Section with Icon */}
          <div className="flex items-center space-x-3 mb-4 sm:mb-0">
            <img src="/book.svg" alt="Portfolio Icon" className="w-6 h-6" />
            <div>
              <h2 className="text-xl font-bold">
                B. Moses Model Portfolio - Income - Model Portfolio
              </h2>
            </div>
          </div>

          {/* Status Section with Icon */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-[#A6A6A6] font-medium">Status: </span>
            <span className="text-sm text-black font-medium">Active</span>
            <img
              src="/green-active.svg"
              alt="Status Icon"
              className="w-4 h-4"
            />
          </div>
        </div>

        {/* Content Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-10 gap-6 mt-6">
          {/* Left Column (40%) */}
          <div className="col-span-1 sm:col-span-1 lg:col-span-4 space-y-8 pr-4 border-r-0 lg:border-r border-gray-300">
            <div>
              <p className="text-xs text-[#A6A6A6] font-medium">Strategy</p>
              <p className="text-sm font-medium">
                B. Moses Model Portfolio - Income
              </p>
            </div>
            <div>
              <p className="text-xs text-[#A6A6A6] font-medium">Type</p>
              <p className="text-sm font-medium">Multi-Asset SMA</p>
            </div>
            <div>
              <p className="text-xs text-[#A6A6A6] font-medium">Growth</p>
              <p className="text-sm font-medium">68</p>
            </div>
            <div>
              <p className="text-xs text-[#A6A6A6] font-medium">Defensive</p>
              <p className="text-sm font-medium">32</p>
            </div>
          </div>

          {/* Right Column (60%) */}
          <div className="col-span-1 sm:col-span-1 lg:col-span-6">
            <p className="text-xs text-[#A6A6A6] font-medium mb-1">
              FUND OBJECTIVE & PROCESS
            </p>
            <p className="text-sm text-black font-medium leading-relaxed">
              To deliver an investment return above the market, after fees, over
              rolling 7-year periods. The B. Moses Asset Management Australian
              Income SMA aims to deliver an above-benchmark, tax-effective
              income stream and reasonable capital growth, over the medium to
              long term, by investing in a concentrated portfolio of large-cap
              Australian listed companies, cash, and fixed interest investments.
              We attempt to select stocks which over the long term have robust
              and sustainable business models. The companies should be run by
              competent management teams. Both strategies, when combined, should
              perform well with measurable and good Return on Equity and High
              Earnings per share growth along with interest income from the cash
              and fixed interest investments.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white  mt-4 rounded-lg  shadow-lg">
        {/* Form Fields */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
          {/* Name */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Platform
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                Caprock Merchant Managed Account Platform
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Code
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">CM0021-AU</p>
            </div>
          </div>

          {/* Mobile Number */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Min investment
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">$50,000</p>
            </div>
          </div>

          {/* Date of Birth */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
            <label className="text-xs font-medium text-labelLightColour">
              Investment Manager
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                Caprock Funds Management
              </p>
            </div>
          </div>
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Sub-advisor
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                B. Moses Asset Management
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Risk profile
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                Australian Income 68% Growth / 32% Income
              </p>
            </div>
          </div>

          {/* Mobile Number */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Risk rating
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">High</p>
            </div>
          </div>

          {/* Date of Birth */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
            <label className="text-xs font-medium text-labelLightColour">
              Fund type
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                Australian Mixed Equity and Debt Assets
              </p>
            </div>
          </div>
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Investments
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">
                Index funds, AS ETFs, LICs, Direct Shares & SMAs
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              SMA Fees
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">0.50% (+ GST)</p>
            </div>
          </div>

          {/* Mobile Number */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Investment Manager Fees
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">1.5% + GST</p>
            </div>
          </div>

          {/* Date of Birth */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
            <label className="text-xs font-medium text-labelLightColour">
              Sub Advisor Fees
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">0.75% + GST</p>
            </div>
          </div>
          <div className="col-span-1 pt-4 pl-4 pb-4 border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Strategy inception date
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">31/12/2017</p>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-4 lg:flex mb-4 lg:space-x-4 gap-4">
        {/* Left Section: Two Cards */}
        <div className="flex flex-col flex-[1.5] space-y-4">
          <div className="bg-white pt-4 pl-4 pr-4 rounded-lg shadow-md w-full flex-1">
            <div className="flex justify-between border-b  items-start">
              <div className="flex items-center pb-2 space-x-4">
                <img
                  src="/presention-chart.svg"
                  alt="Account Icon"
                  className="w-5 h-5 rounded-full"
                />
                <h3 className="text-black text-lg font-medium">
                  Current Target Allocation
                </h3>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              {/* Name */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Email */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Mobile Number */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Date of Birth */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>
            </div>
          </div>

          <div className="bg-white pt-4 pl-4 pr-4 rounded-lg shadow-md w-full flex-1">
            <div className="flex justify-between border-b  items-start">
              <div className="flex items-center pb-2 space-x-4">
                <img
                  src="/activity.svg"
                  alt="Account Icon"
                  className="w-5 h-5 rounded-full"
                />
                <h3 className="text-black text-lg font-medium">Risk Profile</h3>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              {/* Name */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Email */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Mobile Number */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>

              {/* Date of Birth */}
              <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                <label className="text-xs font-medium text-labelLightColour">
                  Name
                </label>
                <p className="text-black text-sm font-medium">John Mayer</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section: Account Balance */}
        <div className="bg-white p-6 rounded-lg lg:mt-0 md:mt-0 mt-4 shadow-lg lg:flex-[2.5] border border-gray-200">
          {/* Top Heading */}
          <div className="flex items-center border-b pb-2 mb-6">
            {/* Icon Image */}
            <img
              src="/graph.svg" // Replace with your icon path
              alt="Icon"
              className="w-6 h-6 mr-2"
            />
            {/* Heading */}
            <h3 className="text-lg font-medium text-black">
              B. Moses Asset Management Visualization
            </h3>
          </div>

          <div className="lg:flex">
            {/* Left Column: Allocation Details */}
            <div className="flex-[1] space-y-4 pr-6  border-gray-200">
              <div className="text-sm space-y-8">
                <div className="flex flex-col items-start">
                  <p className="text-labelLightColour mb-1 font-medium ">
                    Australian Income
                  </p>
                  <p className="font-medium text-black">68% Growth</p>
                  <p className="font-medium text-black">32% Income</p>
                </div>
                <div className="flex flex-col items-start">
                  <p className="text-labelLightColour font-medium">
                    Australian Equity
                  </p>
                  <p className="font-medium text-[#68D391]">68%</p>
                </div>
                <div className="flex flex-col items-start">
                  <p className="text-labelLightColour font-medium ">
                    Australian Fixed Interest
                  </p>
                  <p className="font-medium text-[#F56565]">17%</p>
                </div>
                <div className="flex flex-col items-start">
                  <p className="text-labelLightColour font-medium">
                    Australian Cash
                  </p>
                  <p className="font-medium font-medium text-[#4299E1]">15%</p>
                </div>
              </div>
            </div>

            {/* Right Column: Doughnut Chart */}
            <div className="flex-[2] flex flex-col items-center space-y-4 pl-8">
              <div className="w-60 h-60">
                <Doughnut
                  data={dataset}
                  options={options}
                  plugins={[plugin]} // Ensures percentages are displayed in the donut center
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex lg:space-x-6">
        {/* Disclaimer Section */}
        <div className="flex-[1.2] bg-[#F5FBFF] p-4 rounded-lg shadow-md border border-gray-300">
          <div className="flex items-center border-b pb-2 justify-between mb-4">
            <h3 className="text-md font-medium text-black flex items-center">
              <span className="mr-2">
                <img
                  src="/info-circle.svg"
                  alt="Portfolio Icon"
                  className="w-5 h-5"
                />
              </span>
              Disclaimer
            </h3>
            <button className="text-sm font-medium text-labelColour flex items-center">
              <img
                src="/document-download-grey.svg"
                alt="Portfolio Icon"
                className="w-4 h-4 mr-1"
              />
              Download
            </button>
          </div>
          <p className="text-sm font-medium border-b pb-2 text-black leading-relaxed mb-4">
            This communication has been prepared for B. Moses Asset Management
            Pty Limited (ACN 648 245 755), SMA Investment Sub-Adviser, & Caprock
            Merchant Pty Lid (ABN: 40 648 254 755) and AFS Licence 330742).
            platform host. The factsheet has prepared this publication in good
            faith in relation to the facts known to it at the time of
            preparation. This publication contains general financial product
            advice only. In preparing this information, we did not consider the
            investment objectives, financial situation or particular needs of
            any individual investor, and you should not rely on the opinions,
            advice, recommendations and other information contained in this
            publication alone. This publication has been prepared to provide you
            with general information only. It is not intended to take the place
            of professional advice and you should not take action on specific
            issues in reliance on this information. We do not express any view
            about the accuracy or completeness of information that is not
            prepared by us, and no liability is accepled for any errors it may
            contain.
          </p>
          <h4 className="text-md font-medium text-black">Copyright</h4>
          <p className="text-sm text-black font-medium leading-relaxed">
            Copyright in this publication is owned by Caprock Merchant Ply Ltd.
            You may use this information in this publication for your own
            personal use, but you must not (without Caprock Merchant's Pty Ltd
            consent) alter, reproduce or distribute any part of this
            publication, transmit it to any other person or incorporate the
            information into any other document.
          </p>
        </div>

        {/* Documents Section */}
        <div className="flex-[1] bg-white h-60 p-4 md:mt-0 lg:mt-0 mt-4 rounded-lg shadow-md border border-gray-300">
          <div className="flex items-center border-b pb-2 justify-between mb-4">
            <h3 className="text-md font-medium text-black flex items-center">
              <span className="mr-2">
                <img
                  src="/note-2.svg"
                  alt="Portfolio Icon"
                  className="w-5 h-5"
                />
              </span>
              Documents
            </h3>
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex flex-col border-b pb-2 sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
              <p className="text-black font-medium text-sm sm:flex-1 break-words">
                B. Moses Single & Multi Asset IM (Part A) - 010922
              </p>
              <button className="text-labelColour self-start sm:self-start font-medium text-sm underline flex items-center sm:mt-0 sm:ml-4">
                <img
                  src="/document-download-grey.svg"
                  alt="Portfolio Icon"
                  className="w-4 h-4 mr-1"
                />
                Download
              </button>
            </li>

            <li className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
              <p className="text-black font-medium text-sm sm:flex-1 break-words">
                B. Moses Single & Multi Asset IM (Part A) - 010922
              </p>
              <button className="text-labelColour self-start sm:self-start font-medium text-sm underline flex items-center sm:mt-0 sm:ml-4">
                <img
                  src="/document-download-grey.svg"
                  alt="Portfolio Icon"
                  className="w-4 h-4 mr-1"
                />
                Download
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 border-gray-200 space-y-6">
        {/* Header */}
        <div className="flex items-center border-b pb-2 space-x-2">
          <img src="/book-mark.svg" alt="Portfolio Icon" className="w-6 h-6" />

          <h2 className="text-lg font-medium text-black">
            Terms & Conditions/Descriptions
          </h2>
        </div>

        {/* Content Section */}
        <div className="space-y-4 text-black border-b pb-4 font-medium">
          <p className="text-sm text-labelLightColour">Execution</p>
          <p className="text-sm">
            Execution of the chosen investment strategy will be done on a best
            endeavours basis.{" "}
          </p>
          <p className="text-sm">
            The cut-off times in relation to these instructions will be as
            follows:
          </p>
          {/* List */}
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-sm">
              Any soft copy so signed will constitute an executed original
              counterpart, and any print-out of the copy with the relevant
              signatures appearing will also constitute an executed original
              counterpart; and
            </li>
            <li className="text-sm">
              Where a party prints out this document after all parties that are
              signing electronically have done so, the first print-out by that
              party after all signatories who are signing through DocuSign
              digital
              <span className="font-medium"> 'click' acceptance </span> via the
              Platform or other electronic execution method or signature will
              also be an executed original counterpart of this document. Each
              signatory confirms that their signature appearing in the
              agreement, including any such print-out (irrespective of which
              party printed it), is their personal signature authenticating it.
            </li>
          </ul>
        </div>
        <div className="space-y-4 text-black pb-4 font-medium">
          <p className="text-sm text-labelLightColour">Transaction Costs</p>
          <p className="text-sm">
            Execution of the chosen investment strategy will be done on a best
            endeavours basis.{" "}
          </p>
          <p className="text-sm">
            The cut-off times in relation to these instructions will be as
            follows:
          </p>
          {/* List */}
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-sm">
              Any soft copy so signed will constitute an executed original
              counterpart, and any print-out of the copy with the relevant
              signatures appearing will also constitute an executed original
              counterpart; and
            </li>
            <li className="text-sm">
              Where a party prints out this document after all parties that are
              signing electronically have done so, the first print-out by that
              party after all signatories who are signing through DocuSign
              digital
              <span className="font-medium"> 'click' acceptance </span> via the
              Platform or other electronic execution method or signature will
              also be an executed original counterpart of this document. Each
              signatory confirms that their signature appearing in the
              agreement, including any such print-out (irrespective of which
              party printed it), is their personal signature authenticating it.
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-[#FFF5F5] border border-[#FF5050] font-medium text-black text-md  px-4 py-4 mt-4 flex items-center justify-center">
        <img src="/danger.svg" alt="Portfolio Icon" className="w-5 h-5 mr-2" />
        Please fill all the fields
      </div>
      <div className="bg-white p-6  shadow-lg border border-t-0 border border-red-400">
        {/* Form Header */}
        <div className="flex font-medium justify-between items-center border-b border-gray-200 pb-4">
          <div className="flex items-center">
            <img src="/personalcard.svg" alt="Icon" className="w-6 h-6 mr-2" />
            <h2 className="text-lg font-medium text-black">
              Investment Application
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-sm text-labelLightColour mr-2">Date:</p>
            <p className="text-sm  text-black"> 21/09/2023</p>
          </div>
        </div>

        {/* Form Fields */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
          {/* Name */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Name
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">John Mayer</p>
            </div>
          </div>

          {/* Email */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Email
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">john@gmail.com</p>
            </div>
          </div>

          {/* Mobile Number */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
            <label className="text-xs font-medium text-labelLightColour">
              Mobile Number
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">+61678987298</p>
            </div>
          </div>

          {/* Date of Birth */}
          <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
            <label className="text-xs font-medium text-labelLightColour">
              Date of Birth
            </label>
            <div className="rounded-md py-1">
              <p className="text-black text-sm font-medium">1978/04/22</p>
            </div>
          </div>

          {/* Investment Amount */}
          <div className="col-span-1 pt-4 pl-4 pb-4 pr-4 md:border-r">
            <label className="text-sm font-medium text-labelLightColour">
              Amount you would like to invest
            </label>
            <input
              id="amount"
              type="text"
              value={`$${amount}`}
              onChange={handleAmountChange}
              className="text-sm w-full p-2 text-black border rounded-md text-md"
              placeholder="$0"
            />
          </div>

          {/* Confirmation */}
          <div className="col-span-1 md:col-span-3 pt-4 pl-4 pb-4">
            <div className="flex items-center space-x-2">
              <label htmlFor="confirm" className="text-sm text-black">
                I confirm I have read the Information Memorandum and agree to
                the Terms & Conditions
              </label>
            </div>

            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="confirm-yes"
                className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
              />
              <label htmlFor="confirm-yes" className="text-sm text-[#888888]">
                Yes, I Confirm.
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 border-gray-200 space-y-6">
        {/* Header */}
        <div className="flex items-center border-b pb-2 space-x-2">
          <img
            src="/monitor-mobbile.svg"
            alt="Portfolio Icon"
            className="w-6 h-6"
          />

          <h2 className="text-lg font-medium text-black">
            Electronic Execution
          </h2>
        </div>

        {/* Content Section */}
        <div className="space-y-4 text-black border-b pb-4 font-medium">
          <p className="text-sm">
            A party may sign electronically a soft copy of this document and any
            future amendments or variations of this document through the digital
            <span className="font-medium"> 'click' acceptance </span> via the
            Platform or by signing this document by some other electronic method
            (including signing by stylus or pasting of the signatory's
            signature) and bind itself accordingly. This will satisfy any
            statutory or other requirements for this document to be in writing
            and signed by that party.
          </p>

          {/* List */}
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-sm">
              Any soft copy so signed will constitute an executed original
              counterpart, and any print-out of the copy with the relevant
              signatures appearing will also constitute an executed original
              counterpart; and
            </li>
            <li className="text-sm">
              Where a party prints out this document after all parties that are
              signing electronically have done so, the first print-out by that
              party after all signatories who are signing through DocuSign
              digital
              <span className="font-medium"> 'click' acceptance </span> via the
              Platform or other electronic execution method or signature will
              also be an executed original counterpart of this document. Each
              signatory confirms that their signature appearing in the
              agreement, including any such print-out (irrespective of which
              party printed it), is their personal signature authenticating it.
            </li>
          </ul>
        </div>

        {/* Executed as Agreement Section */}
        <div className="space-y-4 text-black font-medium">
          <div className="flex items-center space-x-2">
            <img src="/verify.svg" alt="Portfolio Icon" className="w-6 h-6" />

            <h2 className="text-lg font-medium text-black">
              Executed as an Agreement
            </h2>
          </div>{" "}
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-sm">
              By signing or accepting below, each director or secretary (as
              applicable) acknowledges and accepts the terms and conditions in
              the Agreement.
            </li>
            <li className="text-sm">
              By signing or accepting below, each director or secretary (as
              applicable) consents to electronic execution of this document (in
              whole or in part), represents that they hold the position or are
              the person named with respect to their execution, and authorizes
              any other director or secretary (as applicable) to produce a copy
              of this document bearing his or her signature for the purpose of
              signing the copy to complete its execution under section 127 of
              the Corporations Act. The copy of the signature appearing on the
              copy so executed is to be treated as his or her original
              signature.
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center rounded-lg shadow-lg mt-6 p-4 bg-white">
        {/* Left Section: Back Button */}
        <div className="flex items-center justify-start w-full md:w-1/2 mb-4 md:mb-0">
          <div
            onClick={() => navigate("/dashboard")}
            className="flex items-center space-x-2 text-sm border-2 border-black rounded-full md:text-md font-medium py-1 px-6 text-black cursor-pointer hover:bg-gray-100"
          >
            {/* Image on the left */}
            <img
              src="/bottom-back.svg" // Path to your image
              alt="Back Icon"
              className="w-4 h-4"
            />
            <span className="font-medium">Back</span>
          </div>
        </div>

        {/* Right Section: Download Button */}
        <div className="flex items-center md:justify-end lg:justify-end justify-start w-full md:w-1/2 space-x-4">
          {/* Cancel Button */}
          <button
            onClick={() => console.log("Cancel triggered")}
            className="flex border-2 border-black rounded-full items-center space-x-2 bg-white text-black font-medium py-2 px-4 text-sm hover:bg-gray-100"
          >
            <span>Cancel</span>
          </button>

          {/* Invest Now Button */}
          <button
            onClick={() => console.log("Invest Now triggered")}
            className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 border-2 rounded-full text-sm hover:bg-gray-800"
          >
            <span>Invest Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetails;
